module.exports = "data:application/font-woff2;base64,"